import { assertEx } from '@xylabs/sdk-js'
import axios from 'axios'

export interface XyCheckoutApiCustoemrData {
  email: string
  firstName: string
  lastName: string
  phone?: string
}

export interface XyCheckoutApiAddressData {
  address: string
  address2: string
  city: string
  country: string
  postalCode: string
  region: string
}

interface ApiUrls {
  dev?: string
  local?: string
  prod?: string
}

export const REBILLY_KEYS: ApiUrls = {
  dev: 'pk_sandbox_uSCFz8SZ9mExc-kc9rQvMNSo9TycKuS0PtOHoyO',
  local: 'pk_sandbox_uSCFz8SZ9mExc-kc9rQvMNSo9TycKuS0PtOHoyO',
  prod: 'pk_live_bcB8awIEGclaiQcA_-08xouZstyl2bP5iH51a7P',
}

export const API_URLS: ApiUrls = {
  local: 'http://localhost:3000',
  prod: 'https://production-checkout-api.xy.company',
}

export const REBILY_URLS: ApiUrls = {
  local: 'https://api-sandbox.rebilly.com/v2.1',
  prod: 'https://api.rebilly.com/v2.1',
}

export class XyCheckoutApi {
  private API_URL: string

  constructor(envIn: 'dev' | 'local' | 'prod' = 'prod') {
    let env = envIn

    if (typeof env !== 'string' || !env) {
      // This is left in for library usage when outside of typescript
      env = 'prod'
    }

    this.API_URL = assertEx(API_URLS[env], 'Missing Checkout Api Url')
  }

  async fetchActivePlans() {
    return (await axios.get('/data/active-products.json'))?.data
  }

  async createTransaction(tokenData: { id: string }, orderData: { id: string }, upsellOrderData: { id: string }) {
    const orderInvoiceId = orderData.id
    const upsellOrderInvoiceId = upsellOrderData.id

    let invoiceId: unknown[] | string = ''

    if (orderInvoiceId && upsellOrderInvoiceId) {
      invoiceId = [orderInvoiceId, upsellOrderInvoiceId]
    } else if (!orderInvoiceId && upsellOrderInvoiceId) {
      invoiceId = upsellOrderInvoiceId
    } else {
      invoiceId = orderInvoiceId
    }
    const payloadData = {
      invoiceId,
      paymentToken: tokenData.id,
      url: '',
    }

    return (await axios.post(`${this.API_URL}/transactions`, payloadData))?.data
  }

  async fetchOrCreateCustomer(formData: XyCheckoutApiCustoemrData) {
    return (await axios.post(`${this.API_URL}/customers`, formData))?.data
  }

  async createOrder(formData: unknown) {
    return (await axios.post(`${this.API_URL}/orders`, formData))?.data
  }

  async updateOrder(formData: unknown) {
    return (await axios.post(`${this.API_URL}/orders`, formData))?.data
  }
}
